import { render, staticRenderFns } from "./TopFiveActivity.vue?vue&type=template&id=183c7e02&scoped=true"
import script from "./TopFiveActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./TopFiveActivity.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TopFiveActivity.vue?vue&type=style&index=0&id=183c7e02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183c7e02",
  null
  
)

export default component.exports